import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../stores/hook';
import { setSwiperAutoPlay, setVideoShow, setVideoUrl } from '../GetStarted/GetStartedSlice';

interface HomeVideoModalProps {
}

const HomeVideoModal: React.FC<HomeVideoModalProps> = () => {
    const [isShow, setIsShow] = useState<boolean>(false);
    const [url, setUrl] = useState<any>('');
    const videoShow = useAppSelector((state) => state.getStarted.videoShow);
    const videoUrl = useAppSelector((state) => state.getStarted.videoUrl);
    const dispatch = useAppDispatch();
    const listenerRef = useRef(null);

    useEffect(() => {
        if (videoShow) {
            setIsShow(true);
            document.getElementsByClassName('home-video')[0].play();
            document.querySelector('body').style.overflow = 'hidden';
        }
    }, [videoShow]);

    useEffect(()=>{
        handleVideo();
    },[videoShow,videoUrl]);

    useEffect(() => {
        if (videoUrl != '' && !videoUrl.includes("undefined")) {
            setUrl(videoUrl);
        }
    }, [videoUrl]);

    const handleVideo = () => {
      const videoElement = document.getElementsByClassName('home-video')[0];
      const videoDivElement = document.getElementsByClassName('video-div')[0];
      if (videoElement && videoDivElement) {
          videoDivElement.appendChild(videoElement);
      }
    }

    const handleClick = () => {
        setIsShow(false);
        dispatch(setVideoShow(false));
        dispatch(setVideoUrl(''));
        dispatch(setSwiperAutoPlay(true));
        const video = document.getElementsByClassName('home-video')[0];
        if(video){
          video.pause();
          video.currentTime = 0;
        }
        document.querySelector('body').style.overflow = '';
    }

    useEffect(() => {
    const handleLiener = (event: any) => {
      const targetDiv = document.getElementsByClassName('home-video')[0];
      if (targetDiv && !targetDiv.contains(event.target)) {
        handleClick();
      }
    };

    listenerRef.current = handleLiener;

    if (isShow) {
      document.addEventListener('click', handleLiener);
    } else {
      document.removeEventListener('click', handleLiener);
    }

    return () => {
      document.removeEventListener('click', listenerRef.current);
    };
  }, [isShow]);

    return (
        <div className={isShow ? "modal-wrapper show" : "modal-wrapper"} style={{padding:"44px",overflow:"hidden"}}>
            <button title="Close" onClick={handleClick} style={{width: '40px',height: '40px',background: 'rgb(30, 30, 30)',position: 'absolute',top: '0',right: '0'}}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{width: '23px',fill: 'white'}}>
                <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path>
              </svg>
            </button>
            <div className="modal-dialog">
              <div className="modal-content-wrapper" style={{maxWidth:"100%"}}>
                <div className="alert-wrapper" style={{background: 'transparent'}}>
                  <div className='video-div'></div>
                  <video className='home-video' controls autoPlay style={{width:"1600px",maxWidth:"100%",height:"auto",margin:"0 auto",display:"block"}}>
                    <source src={url} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
        </div>
    );
}
export default HomeVideoModal;